export default {
  default_settings: {},
  events:{},
  schedule_avalability:{}
}
